import { render, staticRenderFns } from "./ApplicantCreditReport.vue?vue&type=template&id=24b3ac40&scoped=true&"
import script from "./ApplicantCreditReport.vue?vue&type=script&lang=js&"
export * from "./ApplicantCreditReport.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantCreditReport.vue?vue&type=style&index=0&id=24b3ac40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b3ac40",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CreditHistoryDrawer: require('/codebuild/output/src2428694706/src/cc-portal/components/CreditHistoryDrawer.vue').default})
